import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const CategoryTreeWrapper = styled.div`
	font-size: smaller;
	height: 100%;
	overflow: clip scroll;
`;

export const Section = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 10px;
`;

export const BottomSection = styled(Section)`
	border-top: 1px solid ${colors.grey3};
	padding: 3% 0;
	display: flex;
	justify-content: center;
	margin-top: auto;
`;
